module.exports = __webpack_public_path__ + "public/media/wrongTone.919017fd.wav";